// extracted by mini-css-extract-plugin
export var compactFilters = "_d2-4";
export var detailImage = "_d2-1";
export var dropdownContainer = "_d2-2";
export var imageContainer = "_d2-0";
export var selectedCard = "_d2-3";